
import { defineComponent } from 'vue';
import { config } from '@/shared/constants';

export default defineComponent({
  name: 'ReadMore',
  emits: ['translate'],
  props: {
    moreText: {
      type: String,
      default: 'Read more',
    },
    lessText: {
      type: String,
      default: 'Read less',
    },
    text: {
      type: String,
    },
    textEn: {
      type: String,
    },
    isTranslateEnabled: {
      type: Boolean,
    },
    max: {
      type: Number,
      default: 100,
    },
  },
  data() {
    return {
      isReadMore: false,
      languageId: 'sk',
    };
  },

  computed: {
    showTranslateButton(): boolean {
      return this.isTranslateEnabled && config.LANGUAGE === 'en';
    },
    showOriginalTextButton(): boolean {
      return config.LANGUAGE === 'en' && this.languageId === 'en';
    },
    targetText() {
      return this.languageId === 'en' && this.textEn ? this.textEn : this.text;
    },
    texts() {
      let text = this.targetText;
      if (!text) return [''];

      if (text.length > this.max) {
        const lastIndex = text.lastIndexOf(' ', this.max);
        const index = lastIndex > 0 ? lastIndex : this.max;
        let first = text.substring(0, index);
        if (!this.isReadMore) {
          first += '...';
        }
        const second = text.substring(index);
        return [first, second];
      }

      return [text];
    },
  },

  async created() {
    if (config.LANGUAGE === 'en' && this.textEn) {
      this.languageId = 'en';
    }
  },

  methods: {
    triggerReadMore(b: boolean) {
      this.isReadMore = b;
    },
    showOriginalText() {
      this.languageId = 'sk';
    },
    showTranslation() {
      this.languageId = 'en';
    },
    async translate() {
      if (this.textEn) {
        this.languageId = 'en';
        return;
      }
      this.$emit('translate', () => this.showTranslation());
    },
  },
});
